// extracted by mini-css-extract-plugin
module.exports = {"primaryStyle":"TextField_primaryStyle__2Si0l","upper":"TextField_upper__lWw8V"};